module.exports = __webpack_public_path__ + "task_white.d25a4e3cc806c5574101.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/task_white.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/task_white.svg
// module chunks = styles